import Services from "../../components/Services/Services";

function ServicesPage() {
  return <Services />;
}

export default ServicesPage;
